<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="10"
    viewBox="0 0 20 10"
    fill="none"
  >
    <path
      d="M5.47684 7.73632C3.81471 7.73632 2.47956 6.51741 2.47956 5C2.47956 3.48259 3.81471 2.26368 5.47684 2.26368L8.65123 2.27612C9.7139 2.27612 10.5858 3.07214 10.5858 4.04229C10.5858 4.66418 11.1444 5.17413 11.8256 5.17413C12.5068 5.17413 13.0654 4.66418 13.0654 4.04229C13.0654 1.82836 11.0763 0.0124376 8.65123 0.0124376L5.47684 0C2.45232 0 0 2.23881 0 5C0 6.36816 0.613079 7.62438 1.60763 8.53234C2.60218 9.4403 3.96458 9.98756 5.47684 10C6.15804 10 6.71662 9.49005 6.71662 8.86816C6.71662 8.24627 6.15804 7.73632 5.47684 7.73632ZM20 5C20 2.23881 17.5477 0 14.5232 0C13.842 0 13.2834 0.50995 13.2834 1.13184C13.2834 1.75373 13.842 2.26368 14.5232 2.26368C16.1853 2.26368 17.5204 3.48259 17.5204 5C17.5204 6.51741 16.1853 7.73632 14.5232 7.73632L11.3488 7.72388C10.2725 7.73632 9.40055 6.9403 9.41417 5.95771C9.41417 5.33582 8.85559 4.82587 8.17439 4.82587C7.49319 4.82587 6.93461 5.33582 6.93461 5.95771C6.93461 7.07711 7.42507 8.07214 8.22888 8.80597C9.0327 9.5398 10.1226 9.98756 11.3488 9.98756H14.5095C17.5477 10 20 7.76119 20 5Z"
    />
  </svg>
</template>
